export class AddMatchedLeadsProductHiringCitiesDto {
    cities: string[];
    radius: number;
}